import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, CardTitlePrimary } from '@design-system-coopeuch/web';
import { stepperAction } from '../../../../application/actions/stepper';
import { agregarformatoPesos, obtieneNombreApellidos } from '../../../../utils';
import Comprobante from '../Comprobante';
import DocumentoSucursalTemplate from '../DocumentosSucursal';
import tarjetaInternacionalDesk from '../../../assets/img/icon/Desk-Internacional.svg';
import tarjetaInternacionalMobile from '../../../assets/img/icon/Mobile-Internacional.svg';
import iconcedula from '../../../assets/img/icon/icon-Beneficio01.svg';
import iconprevisional from '../../../assets/img/icon/icon-Beneficio03.svg';
import iconliquidacion from '../../../assets/img/icon/icon-Beneficio02.svg';
import Botonera from '../Footer';
import { properties } from '../../../../utils/properties';
import { FuturaTarjetaWrapper } from './styles';

const BlackCardFinalizada = () => {
  const { futuratarjeta } = properties;
  const { boteneraTextos } = futuratarjeta;
  const dispatch = useDispatch();
  const [state] = useState({
    "menuPosition": 5,
    "botonera": [{ nameUno: boteneraTextos.botonDos, nameDos: boteneraTextos.botonUno }],
  });
  const [fechaCreacionNueva, setFechaCreacionNueva] = useState('');
  const [emailNuevo, setEmailNuevo] = useState('');
  const [nombreSocio, setNombreSocio] = useState('');
  const [cupoPesosNuevo, setCupoPesosNuevo] = useState('');
  const [cupoDolaresNuevo, setCupoDolaresNuevo] = useState('');

  const storeDataVerificacion = useSelector((store) => store.entities.verificacion.response);

  useEffect(() => {
    dispatch(stepperAction.fetchStepper(5));
  }, []);

  useEffect(() => {
    if (Object.keys(storeDataVerificacion).length && 'data' in storeDataVerificacion) {
      const { data } = storeDataVerificacion;
      const { nombres, apPaterno, apMaterno, email, fechaCreacion, cupoPesos, cupoDolares } = data;

      setEmailNuevo(email);
      setCupoPesosNuevo(cupoPesos);
      setCupoDolaresNuevo(cupoDolares);
      setFechaCreacionNueva(fechaCreacion);

      setNombreSocio(obtieneNombreApellidos(nombres, apPaterno, apMaterno));
    } else {
      window.location.replace('/');
    }
  }, [storeDataVerificacion]);

  const volveraCoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
  }

  const volveraCoopeuchNoSocios = () => {
    window.location.href = properties.urlNoSocios;
  }

  const { menuPosition, botonera } = state;

  return (
    <>
      {Object.keys(storeDataVerificacion).length > 0 &&
        <FuturaTarjetaWrapper>
          <div className="Titulo">
            <h1>Tu Tarjeta de Crédito te está esperando en Coopeuch</h1>
          </div>
          <div className="futura-tarjeta-header-black">
            <div className="t-internacional t-internacional-texto">
              <p className="titulo">{properties.futuratarjeta.blackcard}</p>
              <p className="subtitulo">Permite acceder a la red de aceptación global de Mastercard, con exclusivos beneficios en Chile y el extranjero</p>
            </div>
            <div className="t-internacional">
              <img className="tarjetainternacional desktop" src={tarjetaInternacionalDesk} alt="internacional" />
              <img className="tarjetainternacional mobile" src={tarjetaInternacionalMobile} alt="internacional" />
              
              <div className="texto">
                <p className="p-internacional">
                  {`$ ${agregarformatoPesos(cupoPesosNuevo)} + US ${agregarformatoPesos(cupoDolaresNuevo)}`}
                </p>
                <p className="p-internacional-dos">
                  {nombreSocio}
                </p>
              </div>
            </div>
          </div>

          <div className="card">
            <Card className="Card-Class">
              <CardTitlePrimary title="¿Cuáles son los beneficios?" />
              <CardContent>
                <div className="contenedor-blackcard">
                  <div className="info">
                    <img className="iconcedula" src={iconcedula} alt="cedula" />
                    <p className="p-mensaje">{properties.futuratarjeta.Beneficios.beneficioUno}</p>
                    <p className="p-coment">
                      {properties.futuratarjeta.Beneficios.textoUno}
                    </p>
                  </div>
                  <div className="info">
                    <img className="iconliquidacion" src={iconliquidacion} alt="liquidacion" />
                    <p className="p-mensaje">{properties.futuratarjeta.Beneficios.beneficioDos}</p>
                    <p className="p-coment">
                      {properties.futuratarjeta.Beneficios.textoDos}
                    </p>
                  </div>
                  <div className="info">
                    <img className="iconprevision" src={iconprevisional} alt="prevision" />
                    <p className="p-mensaje">{properties.futuratarjeta.Beneficios.beneficioTres}</p>
                    <p className="p-coment">{properties.futuratarjeta.Beneficios.textoTres}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
            <div className="contenerdor-componente">
              <div className="contedor-comprobante">
                <Comprobante
                  data={storeDataVerificacion.data}
                  fechaCreacion={fechaCreacionNueva}
                  email={emailNuevo}
                />
              </div>
              <div className="contedor-sucursal">
                <DocumentoSucursalTemplate />
              </div>
            </div>
          </div>

          <Botonera
            tituloboton={botonera}
            verificarFunction={volveraCoopeuchNoSocios}
            volverHome={volveraCoopeuch}
            estadoBotonUno
            estadoBotonDos={false}
            nombreDinamicoResponsive={false}
            activeMenu={menuPosition}
          />
        </FuturaTarjetaWrapper>}
    </>
  );
}

export default BlackCardFinalizada;
